import React from 'react';

export default function AddAttributeModal({ showModal, closeModal, triggerRefresh }) {
  const [formState, setFormState] = React.useState({ name: '', type: 'select' });
  const [submitting, setSubmitting] = React.useState(false);
  const [submitSuccess, setSubmitSuccess] = React.useState(null);

  React.useEffect(() => {
    if (showModal) {
      setFormState({ name: '', type: 'select' });
      setSubmitSuccess(null);
    }
  }, [showModal]);

  const handleField = (k, v) => setFormState((s) => ({ ...s, [k]: v }));

  const submitCreate = async (e) => {
    e && e.preventDefault();
    setSubmitting(true);
    setSubmitSuccess(null);
    try {
      const form = new FormData();
      form.append('action', 'tpwvs_create_attribute');
      form.append('security', window.tpwvs_admin_settings.create_nonce || '');
      form.append('name', formState.name);
      form.append('type', formState.type);

      const res = await fetch(window.tpwvs_admin_settings.api_url, { method: 'POST', body: form });
      const json = await res.json();
      if (json && json.success) {
        setSubmitSuccess({ message: json.data && json.data.message ? json.data.message : 'Attribute created' });
        if (triggerRefresh) triggerRefresh();
      } else {
        setSubmitSuccess({ error: json && json.data && json.data.message ? json.data.message : 'Create failed' });
      }
    } catch (err) {
      setSubmitSuccess({ error: err.message || 'Network error' });
    } finally {
      setSubmitting(false);
    }
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black opacity-40" onClick={closeModal} />
      <div className="bg-white rounded-lg shadow-lg z-50 w-full max-w-2xl p-8">
        <h4 className="text-xl font-semibold mb-2">Add Attribute</h4>
        <p className="text-base text-gray-700 !text-base !leading-[1.4] !m-0">Attributes let you define extra product data, such as size or color. You can use these attributes in the shop sidebar using the "layered nav" widgets.</p>
        {submitSuccess && submitSuccess.message ? (
          <div className="mb-4">
            <div className="text-green-700">{submitSuccess.message}</div>
            <div className="mt-3"><button onClick={closeModal} className="px-3 py-1 bg-indigo-600 text-white rounded">Close</button></div>
          </div>
        ) : (
          <form onSubmit={submitCreate}>
            <div className="grid grid-cols-1 gap-3">
              <label className="block">
                <div className="text-base text-heading mb-1 font-semibold">Name</div>
                <input
                  required
                  value={formState.name}
                  onChange={(e) => handleField('name', e.target.value)}
                  className="block w-full rounded-md border border-gray2 bg-white px-2 py-1 text-base text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-theme transition-colors"
                />
                <p className="text-base text-gray-700 !text-base !leading-[1.4] !m-0">Name for the attribute (shown on the front-end).</p>
              </label>

              <label className="block">
                <div className="text-base text-heading mb-1 font-semibold">Type</div>
                <select value={formState.type} onChange={(e) => handleField('type', e.target.value)} className="col-start-1 row-start-1 w-full appearance-none rounded-md border border-gray2 bg-white py-1 px-2 pr-6 text-base text-gray-900 outline-0 focus:outline-none focus:border-theme sm:text-sm">
                  <option value="select">Select</option>
                  <option value="color">Color</option>
                  <option value="image">Image</option>
                </select>
                <p className="text-base text-gray-700 !text-base !leading-[1.4] !m-0">Determines how this attribute's values are displayed.</p>
              </label>
            </div>

            {submitSuccess && submitSuccess.error && (
              <div role="alert" className="mt-3 p-2 bg-red-50 border border-red-200 text-sm text-red-800 rounded-md">
                {submitSuccess.error}
              </div>
            )}

            <div className="mt-3 flex items-center gap-2">
              <button type="submit" disabled={submitting} className="px-3 py-1.5 bg-theme text-white rounded text-sm">{submitting ? 'Creating…' : 'Create'}</button>
              <button type="button" onClick={closeModal} className="px-2 py-1 border rounded text-sm">Cancel</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
